interface IIdGenOptions {
  byteCount: number;
  detectCollisions: boolean;
  saveIds: boolean;
  type: "hex" | "base64" | "custom";
  alphabet?: string;
}

export class IdGen {
  private options: IIdGenOptions = { byteCount: 8, detectCollisions: true, saveIds: false, type: "hex" };
  private collisionDetector: Record<string, string> = {};

  public constructor(_options?: Partial<IIdGenOptions>) {
    this.options = { ...this.options, ..._options };
    if (this.options.detectCollisions) this.collisionDetector = {};
  }

  static get unsecure(): IdGen {
    if (!this._unsecure) this._unsecure = new IdGen({ byteCount: 8, detectCollisions: false, type: "hex" });
    return this._unsecure;
  }
  private static _unsecure?: IdGen;

  public get(_options?: Partial<IIdGenOptions>): string {
    const options = { ...this.options, ..._options };
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let id: string = "";
      switch (options.type) {
        case "hex": {
          for (let i = 0; i < options.byteCount; i++) {
            const b = Math.floor(Math.random() * 255.9999);
            id += IdGen.#byteToHex(b);
          }
          break;
        }
        case "custom": {
          const alphabet = options.alphabet || "0123456789";
          for (let i = 0; i < options.byteCount; i++) {
            const b = Math.floor(Math.random() * (alphabet.length - 0.0001));
            id += alphabet[b];
          }
          break;
        }
        default:
          throw new Error("Not handled so far!");
      }
      if (!options.detectCollisions) {
        if (options.saveIds) this.collisionDetector[id] = id;
        return id;
      }
      if (!this.collisionDetector[id]) {
        this.collisionDetector[id] = id;
        return id;
      }
    }
  }

  static #byteToHex(byte: number): string {
    return ("0" + (byte & 0xff).toString(16)).slice(-2);
  }
}
